export type Scope = "drProx" | "saludProx" | "reports" | "operational";
export type PermissionAccessRole = "OSA" | "OA" | "FD" | "HP" | "HO";

export type Module = "calendar" | 
"patients" | 
"newPatient" | 
"newDiagnosis" | 
"scheduleAppointment" | 
"editAppointment" | 
"viewFile" | 
"recordDetails" | 
"newAppointment" | 
"newRecord" | 
"documents" | 
"studies" | 
"publicProfile" | 
"offices" | 
"services" | 
"addService" | 
"addOffice" | 
"addSchedule" | 
"account" | 
"devices" | 
"chat" | 
"quiz" | 
"blog" | 
"org" | 
"reports"|
"dashboard"|
"appointments"|
"financial"|
"personalInfo" |
"myServices"
;

export enum PermissionLevel
{
    READ = "read",
    WRITE = "write",
    NONE = "none"
} 

export interface IUpdatePermission
{
    scope: Scope
    permissions: IPermission[]
}
export interface IPermission
{
    level: PermissionLevel,
    permission: Module
}

export interface IUserPermission
{
    _id?: string,
    /**
     * Username or email
     */
    // username: string,
    // userId: number | string,
    user: {
        username: string,
        email: string,
        userId?: string
    }
    saludProx?: IPermission[],
    drProx: IPermission[],
    reports: IPermission[],
    operational?: IPermission[],
    organizationId?: number
}

export interface IDefaultPermission
{
    _id?: string,
    role: {
        value: PermissionAccessRole,
        description: string
    },
    scope:Scope,
    access: IPermission[]
}
